var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#004f90",
      fillOpacity: 1
    },
    d: "M 8 6.667969 L 8.667969 6.667969 C 9.035156 6.667969 9.332031 6.367188 9.332031 6 C 9.332031 5.632812 9.035156 5.332031 8.667969 5.332031 L 8 5.332031 C 7.632812 5.332031 7.332031 5.632812 7.332031 6 C 7.332031 6.367188 7.632812 6.667969 8 6.667969 Z M 8 6.667969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#004f90",
      fillOpacity: 1
    },
    d: "M 11.332031 6.667969 L 20 6.667969 C 20.367188 6.667969 20.667969 6.367188 20.667969 6 C 20.667969 5.632812 20.367188 5.332031 20 5.332031 L 11.332031 5.332031 C 10.964844 5.332031 10.667969 5.632812 10.667969 6 C 10.667969 6.367188 10.964844 6.667969 11.332031 6.667969 Z M 11.332031 6.667969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#004f90",
      fillOpacity: 1
    },
    d: "M 33.949219 21.332031 L 32.5 21.332031 C 32.496094 21.332031 32.492188 21.332031 32.484375 21.332031 C 32.183594 21.335938 31.882812 21.378906 31.589844 21.46875 C 31.566406 21.472656 31.546875 21.480469 31.523438 21.488281 C 31.171875 21.609375 30.84375 21.792969 30.554688 22.035156 C 30.699219 20.5 31.460938 18.273438 34.339844 16.574219 C 34.648438 16.382812 34.746094 15.980469 34.5625 15.667969 C 34.378906 15.355469 33.980469 15.25 33.664062 15.425781 C 31.875 16.398438 30.476562 17.960938 29.714844 19.851562 C 29.679688 19.734375 29.640625 19.621094 29.601562 19.515625 C 29.265625 18.636719 28.714844 17.859375 28 17.25 L 28 6 C 28 4.894531 27.105469 4 26 4 L 23.210938 4 C 22.929688 3.203125 22.179688 2.671875 21.332031 2.667969 L 17.761719 2.667969 C 17.203125 1.070312 15.691406 0 14 0 C 12.308594 0 10.796875 1.070312 10.238281 2.667969 L 6.667969 2.667969 C 5.824219 2.671875 5.070312 3.203125 4.789062 4 L 2 4 C 0.894531 4 0 4.894531 0 6 L 0 38 C 0 39.105469 0.894531 40 2 40 L 26 40 C 26.3125 40 26.621094 39.925781 26.894531 39.785156 C 27.503906 39.925781 28.128906 40 28.753906 40 L 31.246094 40 C 36.074219 40 40 35.816406 40 30.667969 L 40 27.78125 C 40 24.226562 37.285156 21.332031 33.949219 21.332031 Z M 28.355469 19.992188 C 28.527344 20.515625 28.652344 21.054688 28.726562 21.601562 C 28.660156 21.570312 28.601562 21.535156 28.53125 21.511719 C 28.203125 21.394531 27.859375 21.332031 27.511719 21.332031 C 27.503906 21.332031 27.5 21.332031 27.496094 21.332031 L 26.050781 21.332031 C 25.867188 21.332031 25.6875 21.347656 25.511719 21.363281 C 25.492188 21.359375 25.480469 21.347656 25.464844 21.34375 C 23.257812 20.902344 23.289062 18.328125 23.371094 17.40625 C 23.796875 17.359375 24.226562 17.335938 24.652344 17.335938 L 24.667969 17.335938 C 26.335938 17.351562 27.8125 18.417969 28.355469 19.996094 Z M 21.582031 36 L 4 36 L 4 8 L 4.789062 8 C 5.070312 8.796875 5.824219 9.332031 6.667969 9.332031 L 21.332031 9.332031 C 22.179688 9.332031 22.929688 8.796875 23.210938 8 L 24 8 L 24 16.011719 C 22.277344 16.070312 22.164062 16.550781 22.101562 16.824219 C 21.867188 18.195312 21.988281 20.625 23.574219 21.90625 C 21.355469 23.019531 19.96875 25.300781 20 27.78125 L 20 30.667969 C 19.996094 32.5625 20.542969 34.414062 21.582031 36 Z M 26.667969 6 L 26.667969 16.433594 C 26.242188 16.253906 25.792969 16.132812 25.332031 16.066406 L 25.332031 8 C 25.332031 7.265625 24.738281 6.667969 24 6.667969 L 23.332031 6.667969 L 23.332031 5.332031 L 26 5.332031 C 26.367188 5.332031 26.667969 5.632812 26.667969 6 Z M 6.667969 4 L 10.734375 4 C 10.757812 3.996094 10.777344 3.992188 10.800781 3.988281 C 10.84375 3.980469 10.882812 3.972656 10.921875 3.960938 C 10.964844 3.949219 11.007812 3.933594 11.046875 3.910156 C 11.15625 3.851562 11.246094 3.761719 11.304688 3.648438 C 11.328125 3.609375 11.34375 3.570312 11.359375 3.527344 C 11.367188 3.507812 11.375 3.488281 11.382812 3.464844 C 11.636719 2.226562 12.730469 1.332031 13.996094 1.332031 C 15.265625 1.332031 16.355469 2.226562 16.609375 3.464844 C 16.617188 3.488281 16.625 3.511719 16.636719 3.535156 C 16.648438 3.570312 16.660156 3.601562 16.675781 3.632812 C 16.699219 3.675781 16.726562 3.714844 16.757812 3.753906 C 16.777344 3.777344 16.796875 3.800781 16.820312 3.824219 C 16.859375 3.855469 16.902344 3.886719 16.949219 3.910156 C 17.042969 3.972656 17.152344 4.007812 17.265625 4 L 21.332031 4 C 21.703125 4 22 4.300781 22 4.667969 L 22 7.332031 C 22 7.703125 21.703125 8 21.332031 8 L 6.667969 8 C 6.300781 8 6 7.703125 6 7.332031 L 6 4.667969 C 6 4.300781 6.300781 4 6.667969 4 Z M 2 38.667969 C 1.632812 38.667969 1.332031 38.367188 1.332031 38 L 1.332031 6 C 1.332031 5.632812 1.632812 5.332031 2 5.332031 L 4.667969 5.332031 L 4.667969 6.667969 L 4 6.667969 C 3.265625 6.667969 2.667969 7.265625 2.667969 8 L 2.667969 36 C 2.667969 36.738281 3.265625 37.332031 4 37.332031 L 22.640625 37.332031 C 23.128906 37.839844 23.671875 38.289062 24.265625 38.667969 Z M 38.667969 30.667969 C 38.667969 35.078125 35.335938 38.667969 31.246094 38.667969 L 28.753906 38.667969 C 24.664062 38.667969 21.332031 35.078125 21.332031 30.667969 L 21.332031 27.78125 C 21.332031 24.960938 23.449219 22.667969 26.050781 22.667969 L 27.523438 22.667969 C 27.710938 22.667969 27.902344 22.703125 28.082031 22.765625 C 28.855469 23.078125 29.355469 23.839844 29.332031 24.671875 L 29.332031 25.332031 C 29.332031 25.703125 29.632812 26 30 26 C 30.367188 26 30.667969 25.703125 30.667969 25.332031 L 30.667969 24.671875 C 30.640625 23.835938 31.136719 23.074219 31.910156 22.761719 L 31.941406 22.753906 C 32.117188 22.699219 32.296875 22.667969 32.476562 22.664062 L 33.949219 22.664062 C 36.550781 22.667969 38.667969 24.960938 38.667969 27.78125 Z M 38.667969 30.667969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "#004f90",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(61.960784%,76.862745%,10.588235%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 321.55 307.65 C 320.3 308.05 290.15 318.6 290.15 358.4 C 290.15 363.1 293.95 366.95 298.65 366.95 C 303.4 366.95 307.2 363.1 307.2 358.4 C 307.2 331.3 326.1 324.15 327.05 323.8 C 331.5 322.3 333.9 317.45 332.4 313 C 330.9 308.55 326.05 306.15 321.55 307.65 Z M 321.55 307.65 ",
    transform: "matrix(0.078125,0,0,0.078125,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 8.667969 11.332031 L 6.667969 11.332031 C 5.929688 11.332031 5.332031 11.929688 5.332031 12.667969 L 5.332031 14.667969 C 5.332031 15.402344 5.929688 16 6.667969 16 L 8.667969 16 C 9.402344 16 10 15.402344 10 14.667969 L 10 12.667969 C 10 11.929688 9.402344 11.332031 8.667969 11.332031 Z M 6.667969 14.667969 L 6.667969 12.667969 L 8.667969 12.667969 L 8.667969 14.667969 Z M 6.667969 14.667969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "#004f90",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(61.960784%,76.862745%,10.588235%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 110.95 145.05 L 85.35 145.05 C 75.9 145.05 68.25 152.7 68.25 162.15 L 68.25 187.75 C 68.25 197.15 75.9 204.8 85.35 204.8 L 110.95 204.8 C 120.35 204.8 128 197.15 128 187.75 L 128 162.15 C 128 152.7 120.35 145.05 110.95 145.05 Z M 85.35 187.75 L 85.35 162.15 L 110.95 162.15 L 110.95 187.75 Z M 85.35 187.75 ",
    transform: "matrix(0.078125,0,0,0.078125,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "#004f90",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(61.960784%,76.862745%,10.588235%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 110.95 221.9 L 85.35 221.9 C 75.9 221.9 68.25 229.5 68.25 238.95 L 68.25 264.55 C 68.25 273.95 75.9 281.6 85.35 281.6 L 110.95 281.6 C 120.35 281.6 128 273.95 128 264.55 L 128 238.95 C 128 229.5 120.35 221.9 110.95 221.9 Z M 85.35 264.55 L 85.35 238.95 L 110.95 238.95 L 110.95 264.55 Z M 85.35 264.55 ",
    transform: "matrix(0.078125,0,0,0.078125,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "#004f90",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(61.960784%,76.862745%,10.588235%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 110.95 298.7 L 85.35 298.7 C 75.9 298.7 68.25 306.3 68.25 315.75 L 68.25 341.35 C 68.25 350.75 75.9 358.4 85.35 358.4 L 110.95 358.4 C 120.35 358.4 128 350.75 128 341.35 L 128 315.75 C 128 306.3 120.35 298.7 110.95 298.7 Z M 85.35 341.35 L 85.35 315.75 L 110.95 315.75 L 110.95 341.35 Z M 85.35 341.35 ",
    transform: "matrix(0.078125,0,0,0.078125,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "#004f90",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(61.960784%,76.862745%,10.588235%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 110.95 375.45 L 85.35 375.45 C 75.9 375.45 68.25 383.1 68.25 392.55 L 68.25 418.15 C 68.25 427.55 75.9 435.2 85.35 435.2 L 110.95 435.2 C 120.35 435.2 128 427.55 128 418.15 L 128 392.55 C 128 383.1 120.35 375.45 110.95 375.45 Z M 85.35 418.15 L 85.35 392.55 L 110.95 392.55 L 110.95 418.15 Z M 85.35 418.15 ",
    transform: "matrix(0.078125,0,0,0.078125,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "#004f90",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(61.960784%,76.862745%,10.588235%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 153.6 187.75 L 273.05 187.75 C 277.8 187.75 281.6 183.9 281.6 179.2 C 281.6 174.5 277.8 170.7 273.05 170.7 L 153.6 170.7 C 148.9 170.7 145.05 174.5 145.05 179.2 C 145.05 183.9 148.9 187.75 153.6 187.75 Z M 153.6 187.75 ",
    transform: "matrix(0.078125,0,0,0.078125,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "#004f90",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(61.960784%,76.862745%,10.588235%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 247.45 247.45 L 153.6 247.45 C 148.9 247.45 145.05 251.3 145.05 256 C 145.05 260.7 148.9 264.55 153.6 264.55 L 247.45 264.55 C 252.2 264.55 256 260.7 256 256 C 256 251.3 252.2 247.45 247.45 247.45 Z M 247.45 247.45 ",
    transform: "matrix(0.078125,0,0,0.078125,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "#004f90",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(61.960784%,76.862745%,10.588235%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 230.4 324.25 L 153.6 324.25 C 148.9 324.25 145.05 328.1 145.05 332.8 C 145.05 337.5 148.9 341.35 153.6 341.35 L 230.4 341.35 C 235.1 341.35 238.95 337.5 238.95 332.8 C 238.95 328.1 235.1 324.25 230.4 324.25 Z M 230.4 324.25 ",
    transform: "matrix(0.078125,0,0,0.078125,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "#004f90",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(61.960784%,76.862745%,10.588235%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 230.4 401.05 L 153.6 401.05 C 148.9 401.05 145.05 404.9 145.05 409.6 C 145.05 414.3 148.9 418.15 153.6 418.15 L 230.4 418.15 C 235.1 418.15 238.95 414.3 238.95 409.6 C 238.95 404.9 235.1 401.05 230.4 401.05 Z M 230.4 401.05 ",
    transform: "matrix(0.078125,0,0,0.078125,0,0)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiet);
export default __webpack_public_path__ + "static/media/diet.0056afda.svg";
export { ForwardRef as ReactComponent };